(ns dashboard.db.event-organizer
  (:require
   [clojure.string :refer [blank?]]
   [malli.core :as mc]
   [malli.transform :as mt]
   [dashboard.utils :refer [parse-int]]
   ["date-fns" :refer [parse]]))

;; Steps to parse booking data
;; 1. Rename keys
;; 2. Extract information from productName
;; 3. Extract guest and accompanying guest information

(def cartier-booking-key-map
  {"管理番号" :externalId
   "予約コード" :bookingId
   "予約商品名" :productName
   "予約商品利用日" :date
   "セイ" :guestLastName
   "メイ" :guestFirstName
   "姓" :guestLastNameJp
   "名" :guestFirstNameJp
   "人数" :guestNumbers
   "お連れ様(1）カナ" :guest1Name
   "お連れ様(1）氏名（姓　名)" :guest1NameJp
   "お連れ様(1）性別" :guets1Gender
   "お連れ様(1）年齢" :guest1Age
   "お連れ様(2）カナ" :guest2Name
   "お連れ様(2）氏名（姓　名）" :guest2NameJp
   "お連れ様(2）性別" :guets2Gender
   "お連れ様(2）年齢" :guest2Age
   "お客様情報備考" :comment
   "ハイヤー利用" :hireCar
   "宿泊手配（有・無）" :accommodationArrangement
   "BTQ担当者名" :inviterName
   "BTQ担当者フルネーム（漢字）" :inviterName
   "BTQ名" :boutiqueName
   "BTQ No." :boutiqueExternalId
   "顧客ID" :clientId
   "POS担当者名" :posInviterName
   "POS名" :posName
   "交通手配（有・無）" :transportationArrangement})


(def CartierBooking
  [:map
   ["管理番号" string?]
   ["予約コード" string?]
   ["予約商品名" string?]
   ["予約商品利用日" string?]
   ["セイ" string?]
   ["メイ" string?]
   ["姓" string?]
   ["名" string?]
   ["人数" [:int {:string/trim true}]]
   ["お客様情報備考" string?]
   ["顧客ID" string?]
   ["BTQ担当者名" string?]
   ["BTQ名" string?]
   ["BTQ担当者フルネーム（漢字）" string?]
   ["POS名" string?]])

(defn int-trimmer []
  (mt/transformer
   {:decoders
    {:int
     {:compile (fn [schema _]
                 (let [{:string/keys [trim]} (malli.core/properties schema)]
                   (when trim #(cond-> % (string? %) js/parseInt))))}}}))

(def strict-string-transformer
  (mt/transformer
   mt/strip-extra-keys-transformer
   mt/string-transformer
   int-trimmer))

(defn- parse-product-name [s]
  (when (and (some? s) (> (count s) 19))
    (let [start (parse (str (subs s 0 5) (subs s 9 14)) "MM月dd日HH:mm" (js/Date.))
          end (parse (str (subs s 0 5) (subs s 15 20)) "MM月dd日HH:mm" (js/Date.))
          vip? (some? (re-matches #".*VIP.*" s))
          semiprivate? (some? (re-matches #".*セミプライベート.*" s))]
      {:start start
       :end end
       :roomType (cond
                   vip?
                   "VIPルーム"

                   semiprivate?
                   "セミプライベート"

                   :else "セミプライベート")})))

(comment
  (str (subs "【大阪】5月22日(水) 10:30-12:00" 4 9) (subs "【大阪】5月24日(水)　10:30-12:00" 13 18))
  (str (subs "【大阪】5月24日(水)　10:30-12:00" 4 9) (subs "【大阪】5月24日(水)　10:30-12:00" 13 18))
  (str (subs "【東京】5月11日(木)　10:30-12:00　プラチナスロット" 4 9) (subs "【東京】5月11日(木)　10:30-12:00　プラチナスロット" 19 24))
  (parse-product-name "【東京】5月11日(木)　10:30-12:00　プラチナスロット【大阪】5月24日(水)　10:30-12:00")
  (parse-product-name "【大阪】 5月22日(水) 10:30-12:00")
  (str (subs "7月21日(日)　10:30-12:30　プラチナスロット(要承認)" 0 5) (subs "7月21日(日)　10:30-12:30　プラチナスロット(要承認)" 9 14))
  (str (subs "7月23日(日)　10:30-12:30" 0 5) (subs "7月23日(日)　10:30-12:30" 15 20))
  (parse-product-name "7月26日(水)　18:00-20:00（スペシャルナイト)"))

(defn parse-booking [raw-booking]
  (-> (mc/decode CartierBooking raw-booking strict-string-transformer)
      (clojure.set/rename-keys cartier-booking-key-map)
      (merge (parse-product-name (get raw-booking "予約商品名"))
             {:accompanyingGuests (into [] (remove #(blank? (:name %))
                                    [{:name (get raw-booking "お連れ様(1）氏名（姓　名)")
                                      :age (parse-int (get raw-booking "お連れ様(1）年齢"))
                                      :gender (get raw-booking "お連れ様(1）性別")}
                                     {:name (get raw-booking "お連れ様(2）氏名（姓　名)")
                                      :age (parse-int (get raw-booking "お連れ様(2）年齢"))
                                      :gender (get raw-booking "お連れ様(2）性別")}]))})))
